export default "__VITE_ASSET__Bkgxjzbr__"